import { Component } from '@angular/core';

@Component({
  selector: 'app-course-requests-widget',
  templateUrl: './course-requests-widget.component.html',
  styleUrls: [ './course-requests-widget.component.scss' ],
})
export class CourseRequestsWidgetComponent {
  courses = [
    {
      name: 'Angular', date: '10/24/23', author: 'John Doe',
    },
    {
      name: 'React', date: '10/24/23', author: 'Jane Smith',
    },
    {
      name: 'Vue', date: '10/24/23', author: 'Alex Johnson',
    },
    {
      name: 'Angular', date: '10/24/23', author: 'John Doe',
    },
    {
      name: 'React', date: '10/24/23', author: 'Jane Smith',
    },
    {
      name: 'Vue', date: '10/24/23', author: 'Alex Johnson',
    },
    {
      name: 'Angular', date: '10/24/23', author: 'John Doe',
    },
    {
      name: 'React', date: '10/24/23', author: 'Jane Smith',
    },
    {
      name: 'Vue', date: '10/24/23', author: 'Alex Johnson',
    },
    {
      name: 'Angular', date: '10/24/23', author: 'John Doe',
    },
    {
      name: 'React', date: '10/24/23', author: 'Jane Smith',
    },
    {
      name: 'Vue', date: '10/24/23', author: 'Alex Johnson',
    },
    {
      name: 'Angular', date: '10/24/23', author: 'John Doe',
    },
    {
      name: 'React', date: '10/24/23', author: 'Jane Smith',
    },
    {
      name: 'Vue', date: '10/24/23', author: 'Alex Johnson',
    },
    {
      name: 'Angular', date: '10/24/23', author: 'John Doe',
    },
    {
      name: 'React', date: '10/24/23', author: 'Jane Smith',
    },
    {
      name: 'Vue', date: '10/24/23', author: 'Alex Johnson',
    },

  ]

}
